import { BaseResource } from '../core/base-resource';

export class PaymentSetup extends BaseResource {
  applePay?: any;
  paymentPageUrl?: string;
  statusTopic?: string;
}
